import { Separator } from "@/components/ui/separator";

import { MedalIcon } from "./icons";

interface AwardType {
  id: string;
  source?: string;
  title?: string;
  url?: string;
}

interface AwardsProps {
  awards: AwardType[];
}

export default function Awards({ awards }: AwardsProps) {
  if (!awards.length) {
    return null;
  }

  return (
    <div className="mb-10 md:mb-7.5">
      <h3 className="text-20 text-white leading-[1.2em] md:text-24">Awards</h3>
      <ul className="mt-5 gap-4 md:flex md:flex-col md:items-stretch md:gap-[13px]">
        {awards.map(({ id, source, title, url }) => {
          if (!(title && url)) {
            return null;
          }

          return (
            <li
              className="relative flex items-center text-14/[1.43em] text-white/80 md:text-16/[1.5em]"
              key={id}
            >
              <MedalIcon className="mr-2 size-4" />
              <a
                className="link-overlay mr-1 text-maize"
                href={url}
                rel="noopener noreferrer"
                target="_blank"
              >
                {title}
              </a>
              {source && ` - ${source}`}
            </li>
          );
        })}
      </ul>
      <Separator className="mt-7 hidden bg-white/10 md:block" />
    </div>
  );
}
